import { canTrackMixpanel } from "./consent";
import { trackProductEvent } from "./track";

const getAnalyticsLabel = (el) => {
  const text = (el?.textContent || "").trim();
  return (
    el?.getAttribute("data-analytics-label") ||
    el?.getAttribute("aria-label") ||
    text ||
    ""
  ).slice(0, 120);
};

const getAnalyticsId = (el) => {
  return (
    el?.getAttribute("data-analytics-id") ||
    el?.getAttribute("data-testid") ||
    el?.id ||
    ""
  ).slice(0, 120);
};

const getLinkPath = (href) => {
  if (!href) return "";
  try {
    const url = new URL(href, window.location.origin);
    return `${url.pathname}${url.hash || ""}`;
  } catch {
    return href.startsWith("/") ? href : "";
  }
};

export const trackButtonClick = (el, page, user) => {
  if (!canTrackMixpanel(user)) return;
  const buttonId = getAnalyticsId(el);
  trackProductEvent(
    "button_click",
    {
      button_id: buttonId || "unknown",
      label: getAnalyticsLabel(el),
      page,
      role: user?.role,
    },
    user
  );
};

export const trackLinkClick = (el, page, user) => {
  if (!canTrackMixpanel(user)) return;
  const linkPath = getLinkPath(el?.getAttribute("href") || el?.href);
  if (!linkPath) return;
  trackProductEvent(
    "link_click",
    {
      link_path: linkPath,
      label: getAnalyticsLabel(el),
      page,
      role: user?.role,
    },
    user
  );
};

export const trackElementHover = (el, page, user) => {
  if (!canTrackMixpanel(user)) return;
  const elementId = getAnalyticsId(el);
  const elementType = (el?.tagName || "").toLowerCase();
  trackProductEvent(
    "element_hover",
    {
      element_type: elementType,
      element_id: elementId || "unknown",
      label: getAnalyticsLabel(el),
      page,
      role: user?.role,
    },
    user
  );
};

export const trackFormSubmit = (el, page, user) => {
  if (!canTrackMixpanel(user)) return;
  const formId = getAnalyticsId(el);
  trackProductEvent(
    "form_submit",
    {
      form_id: formId || "unknown",
      page,
      role: user?.role,
    },
    user
  );
};

export const trackInputFocus = (el, page, user) => {
  if (!canTrackMixpanel(user)) return;
  const inputId = getAnalyticsId(el);
  trackProductEvent(
    "input_focus",
    {
      input_id: inputId || "unknown",
      page,
      role: user?.role,
    },
    user
  );
};
